import { RefObject, useState } from 'react';
import { Tooltip, TooltipProps } from 'reactstrap';

type BaseTooltipProps = TooltipProps & {
    showOnlyIfOverflownRef?: RefObject<HTMLElement>;
    overflownElementClassName?: string;
};

const BaseTooltip = ({
    target,
    children,
    showOnlyIfOverflownRef,
    overflownElementClassName,
    ...props
}: BaseTooltipProps) => {
    const [state, setState] = useState(false);
    const toggle = () => {
        if (isOverflown()) setState((prev) => !prev);
    };

    const isOverflown = () => {
        if (showOnlyIfOverflownRef && showOnlyIfOverflownRef.current) {
            const element = overflownElementClassName
                ? showOnlyIfOverflownRef.current.getElementsByClassName(
                      overflownElementClassName
                  )[0]
                : showOnlyIfOverflownRef.current;
            if (element) return element.clientWidth < element.scrollWidth;
        }

        return true;
    };

    return (
        <Tooltip target={target} isOpen={state} toggle={toggle} {...props}>
            {children}
        </Tooltip>
    );
};

/**
 * Возвращает MenuItem с всплывающим тултипом
 *
 * @param {string} target id элемента для которого отображать тултип
 * @param {string | null} showOnlyIfOverflownElement элемент при переполнении которого отображать тултип
 * @returns {JSX} JSX MenuItem
 */
export default BaseTooltip;
